export const ETAPA_ENTREGA_CHAVES = {
    SOLICITACAO_DE_VISTORIA: {
        CD_ETAPA: "VIST_16",
    },
    AGENDAR_VISTORIA: {
        CD_ETAPA: "VIST_20",
    },
    AGENDAR_REVISTORIA: {
        CD_ETAPA: "VIST_19",
    },
    AGENDAR_VISTORIA_CLIENTE_NAO_COMPARECEU: {
        CD_ETAPA: "VIST_38",
    },
    AGENDAR_VISTORIA_NAO_REALIZADA: {
        CD_ETAPA: "VIST_39",
    },
    AGENDAR_VISTORIA_AGENDAMENTO_PENDENTE: {
        CD_ETAPA: "VIST_41",
    },
    AGENDAR_VISTORIA_PREVIA: {
        CD_ETAPA: "VIST_61",
    },
    AGENDAR_VISTORIA_UNIDADE_ESTOQUE: {
        CD_ETAPA: "VIST_47",
    },
    REALIZAR_VISTORIA: {
        CD_ETAPA: "VIST_17",
    },
    RESPONDER_FORMULARIO_CONFORME: {
        CD_ETAPA: "VIST_21",
    },
    RESPONDER_FORMULARIO_NAO_CONFORME: {
        CD_ETAPA: "VIST_22",
    },
    LIBERAR_REVISTORIA: {
        CD_ETAPA: "VIST_50",
    },
    VALIDACAO_FINANCEIRA: {
        CD_ETAPA: "VIST_31",
    },
    AGENDAR_ENTREGA: {
        CD_ETAPA: "VIST_24",
    },
    AGENDAR_ENTREGA_AGENDAMENTO_PENDENTE: {
        CD_ETAPA: "VIST_42",
    },
    AGENDAR_ENTREGA_CLIENTE_NAO_COMPARECEU: {
        CD_ETAPA: "VIST_43",
    },
    AGENDAR_ENTREGA_NAO_REALIZADA: {
        CD_ETAPA: "VIST_44",
    },
    REALIZAR_VISTORIA_PREVIA: {
        CD_ETAPA: "VIST_62",
    },
    RESPONDER_VISTORIA_PREVIA_CONFORME_ELETRICA: {
        CD_ETAPA: "VIST_63",
    },
    RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_ELETRICA: {
        CD_ETAPA: "VIST_64",
    },

    RESPONDER_PESQUISA_ENTREGA_CHAVES: {
        CD_ETAPA: "VIST_30",
    },
    RESPONDER_OBRA_CONCLUIDA_ACEITE_UNIDADE: {
        CD_ETAPA: "VIST_49",
    },
    ENTREGA_REALIZADA_ASSINAR_TERMO: {
        CD_ETAPA: "VIST_28",
    },
    AGENDAR_VISTORIA_PREVIA_UNIDADE: {
        CD_ETAPA: "VIST_71",
    },
    REALIZAR_VISTORIA_PREVIA_UNIDADE: {
        CD_ETAPA: "VIST_72",
    },
    RESPONDER_VISTORIA_PREVIA_CONFORME_UNIDADE: {
        CD_ETAPA: "VIST_73",
    },
    RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_UNIDADE: {
        CD_ETAPA: "VIST_74",
    },
};
